import { MainWrapperCSSStyleImpl, MainWrapperCSSStyle } from '../mainwrappercss';

export interface HomeWrapperCSSStyle extends MainWrapperCSSStyle
{
    
}

export class HomeWrapperCSSStyleImpl extends MainWrapperCSSStyleImpl implements HomeWrapperCSSStyle
{   
    getContentDivCSSStyle(): object
    {
        return {
            height: '100%', 
            width: '100%',
            paddingTop:'130px',
            backgroundColor: "white",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/homewrappercss.tsx